import "./customSelect.scss";

const customStyles = (
  height = 49,
  bgcolor = "#EDF2FA",
  color = "#000",
  inputcolor = "#24282a",
  maxHeight = "300px"
) => ({
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Montserrat",
    color: color,
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 1,
    background: "transparent !important",
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: "Montserrat",
    color: color,
    width: "100%",
    borderRadius: 10,
    border: state.isFocused
      ? "1px solid #0D56EB !important"
      : "1px solid #C7D2E3 !important",
    background: bgcolor,
    cursor: "pointer",
    paddingRight: "10px",
    paddingLeft: "10px",
    outline: "none !important",
    boxShadow: "none !important",
    height: `${height}px`, // Overall height
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 8px", // Add some padding for alignment
    backgroundColor: bgcolor,
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0 !important",
    padding: "0 !important",
    backgroundColor: state.isFocused
      ? "transparent !important"
      : `${bgcolor} !important`,
    color: `${color} !important`,
    border: "none !important",
    boxShadow: "none !important",
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    color: isSelected ? "#fff" : "#000",
    backgroundColor: isSelected ? "#0640B9" : isFocused ? "#FFF" : undefined,
    border: "none",
    display: "flex",
    alignItems: "center",
    marginBottom: 5,
    height: `${height - 1}px`,
    borderRadius: 10,
    cursor: "pointer",
    textAlign: "center",
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#fff",
      color: "#000",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#EDF2FA",
    border: "none",
    zIndex: "9 !important",
    overflow: "auto",
    width: "100%",
    maxHeight: maxHeight,
    padding: 10,
    borderRadius: 10,
    fontFamily: "Montserrat",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    height: `${height}px`, // Adjust to match control height
    display: "flex",
    alignItems: "center",
    color: "#000",
  }),
  indicatorSeparator: () => ({
    display: "none", // Hides the separator
  }),
});

export { customStyles };
